import * as React from "react";

export function DailyGoalName({ name }: { name: string; }) {
    return <span>{name}</span>;
}
